import { css } from 'styled-components'

export const paperHoverCss = css`
  cursor: pointer;
  &:hover {
    box-shadow: 0 0 8px rgba(0, 0, 0, 0.4);
  }
`

export const paperBackgroundCss = css`
  background-color: #fafafa;
  box-shadow: 0 0 4px rgb(0 0 0 / 20%);
  border-radius: 5px;
  ${props => (props.withHover ? paperHoverCss : null)}
`

export const unstyledButtonCss = css`
  outline: none;
  border: 0;
  background-color: transparent;
  color: #222;
  text-decoration: none;
  display: inline-block;
  &:active {
    color: #222;
  }
`

export const roundButtonCss = css`
  background-color: #fdcc34;
  padding: 5px 20px;
  border-radius: 15px;
  text-decoration: none;
  margin: 0;
  border: 1px solid #222;
  cursor: pointer;
  color: #222;
  &:active {
    color: #222;
  }
`

const sharedStyles = {
  paperBackgroundCss,
  paperHoverCss,
  unstyledButtonCss,
  roundButtonCss
}

export default sharedStyles
